import clsx from 'clsx';
import { FC, FormEventHandler } from 'react';
import { Control } from 'react-hook-form';
import { Button } from 'atoms/Button';
import { IButton } from 'atoms/Button/types';
import { TextInput } from 'organisms/TextInput';
import styles from './styles.module.css';

export const NewsletterForm: FC<{
  handleSubscribe: FormEventHandler<HTMLFormElement>;
  control: Control;
  placeholder: string;
  button_text: string;
  buttonColor?: IButton['color'];
  centered?: boolean;
  inputClassName?: string;
  className?: string;
  buttonClassName?: string;
}> = ({
  handleSubscribe,
  control,
  placeholder,
  button_text,
  centered,
  inputClassName,
  className,
  buttonClassName,
  buttonColor = 'default',
}) => {
  return (
    // name attribute needs for correct getting form in test
    <form
      onSubmit={handleSubscribe}
      className={clsx(styles.root, className)}
      name="newsletter"
    >
      <div className={styles.inputWrapper}>
        <TextInput
          name="email"
          control={control}
          placeholder={placeholder}
          centered={centered}
          inputClassName={clsx(styles.input, inputClassName)}
          errorClassName={styles.error}
        />
      </div>
      <Button
        type="submit"
        className={clsx(styles.button, buttonClassName)}
        color={buttonColor}
      >
        {button_text}
      </Button>
    </form>
  );
};
